import { ICartProps } from '../../../../contexts/CartContext/CartContext.types';
import {
    IReservePhoneNumbersRequest,
    IReservePhoneNumbersResponse
} from '../../../../api/Idi/Idi.api.types';
import { ReserveNumbers } from '../../../../api/Idi/Idi.api';
import { useGetClosestStoreHook } from './GetClosestStoreHook';
import { IStoreLocation } from '../../../../components/forms/StoreLocator/StoreLocator.types';

export const ReserveNumbersHook = (
    cart: ICartProps,
    onSuccess: () => void,
    onFailure: () => void
) => {
    useGetClosestStoreHook(
        cart,
        (response: IStoreLocation[]) => doReservation(cart, response, onFailure),
        onFailure,
        true
    );

    function doReservation(cart: ICartProps, stores: IStoreLocation[], onFailure: () => void) {
        const request: IReservePhoneNumbersRequest = {
            countOfNumbersToReserve: cart.lineItems.length,
            storeName: `${stores[0].idiName}`
        };

        ReserveNumbers(cart.customerInfo.customerId, request, reservationSuccess, onFailure);
    }

    function reservationSuccess(response: IReservePhoneNumbersResponse) {
        cart.reserveNumberResponse = response;
        onSuccess();
    }
};
